export const TRANSLATION_NAMESPACE = 'page-builder-fe';
const translations = {
  en_GB: {
    RESET: 'Reset',
    SEARCH_MOBILE_BUTTON_TEXT: 'Search',
    SEARCH_BUTTON_TEXT: 'Search',
    RESET_ALL_FILTERS: 'Reset all filters',
    REFINE_SEARCH: 'Refine search',
    MOBILE_REFINEMENT_TITLE: 'Search refinement'
  },
  en_US: {},
  fr_FR: {
    SEARCH_BUTTON_TEXT: 'Rechercher',
    SEARCH_MOBILE_BUTTON_TEXT: 'Rechercher',
    RESET_ALL_FILTERS: 'RAZ des filtres',
    REFINE_SEARCH: 'Affiner la recherche',
    MOBILE_REFINEMENT_TITLE: 'Affinement de la recherche'
  },
  it_IT: {
    RESET: 'Cancella',
    SEARCH_BUTTON_TEXT: 'Ricerca',
    SEARCH_MOBILE_BUTTON_TEXT: 'Ricerca',
    RESET_ALL_FILTERS: 'Cancella',
    REFINE_SEARCH: 'Perfeziona la ricerca',
    MOBILE_REFINEMENT_TITLE: 'Perfezionamento della ricerca'
  },
  de_DE: {
    RESET: 'Zurücksetzen',
    SEARCH_BUTTON_TEXT: 'Suchen',
    SEARCH_MOBILE_BUTTON_TEXT: 'Suchen',
    RESET_ALL_FILTERS: 'Zurücksetzen',
    REFINE_SEARCH: 'Suche verfeinern',
    MOBILE_REFINEMENT_TITLE: 'Suche verfeinern'
  }
};
export default translations;
//# sourceMappingURL=translations.js.map